import React from 'react';
import { ChatMessage, MessageType } from '../models/Chat';

interface ChatBubbleProps {
  message: ChatMessage;
  currentUserId: string;
}

const IMAGE_RE = /^https?:\/\/\S+\.(jpg|jpeg|png|gif|webp)(\?\S*)?$/i;

const Avatar: React.FC<{ name: string }> = ({ name }) => (
  <div style={{
    width: '20px', height: '20px', borderRadius: '50%',
    backgroundColor: '#007aff', color: 'white',
    fontSize: '10px', fontWeight: 700,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    flexShrink: 0, marginTop: '2px'
  }}>
    {(name || '?').charAt(0).toUpperCase()}
  </div>
);

const ChatBubble: React.FC<ChatBubbleProps> = ({ message, currentUserId }) => {
  const isCurrentUser = message.senderId === currentUserId;
  const isEmojiMessage = message.messageType === MessageType.EMOJI && !!message.emoji;
  const isImageMessage = IMAGE_RE.test(message.text.trim());

  const time = message.timestamp.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit'
  });

  return (
    <div style={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: '4px',
      padding: '4px 8px',
      justifyContent: isCurrentUser ? 'flex-end' : 'flex-start'
    }}>
      {!isCurrentUser && <Avatar name={message.senderName} />}

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: isCurrentUser ? 'flex-end' : 'flex-start',
        maxWidth: '75%'
      }}>
        {!isCurrentUser && (
          <div style={{ fontSize: '10px', color: '#888', marginBottom: '2px' }}>
            {message.senderName}
          </div>
        )}

        {isEmojiMessage ? (
          <div style={{ fontSize: '24px', lineHeight: 1 }}>{message.emoji}</div>
        ) : isImageMessage ? (
          <img
            src={message.text.trim()}
            alt=""
            style={{
              width: '250px', maxWidth: '100%', height: '200px',
              objectFit: 'cover', borderRadius: '16px', display: 'block'
            }}
          />
        ) : (
          <div style={{
            backgroundColor: isCurrentUser ? '#007aff' : '#e9e9eb',
            color: isCurrentUser ? 'white' : '#000',
            padding: '10px 14px',
            borderRadius: '16px',
            fontSize: '14px',
            lineHeight: '1.4',
            wordWrap: 'break-word',
            minWidth: '80px'
          }}>
            {message.text}
          </div>
        )}

        <div style={{ fontSize: '10px', color: '#999', marginTop: '2px' }}>
          {time}
        </div>
      </div>

      {isCurrentUser && <Avatar name={message.senderName} />}
    </div>
  );
};

export default ChatBubble;
